// @flow
import React from 'react';

import { createAction } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';
import { v4 as uuidv4 } from 'uuid';

import { createDialog } from 'data/rootUi/actions';
import { mkRootUiData } from 'data/rootUi/types';
import { DIALOG_TYPE as DIALOG_CONFIRMATION, mkConfirmationDialogProps, registerContentView } from 'components/Dialogs/ConfirmationDialog';

import ContentView from './ContentView';

function buildAndRegisterContentView(error) {
  const id = uuidv4();
  registerContentView(id, (<ContentView error={error} />));
  return id;
}

export const createErrorDialog = createAction(
  createDialog.toString(),
  (error) => mkRootUiData({
    type: DIALOG_CONFIRMATION,
    allowNesting: false,
    props: ImmutableMap(mkConfirmationDialogProps({
      title: error.text,
      contentViewId: buildAndRegisterContentView(error),
      confirmLabel: error.actionLabel,
      confirmAction: error.action,
      unregisterContentViewOnClose: true,
    })),
  })
);

